import { createAction } from '@reduxjs/toolkit';
import { responseFailed } from './error';

const onFetchAPRSuccess = (response) => (dispatch) => {
  dispatch(fetchAPRSuccessResponse(response));
};

const onFetchAPRFailure = (response) => (dispatch) => {
  dispatch(responseFailed(response));
};

const fetchAPRSuccessResponse = createAction(
  'calculator/fetchAPRSuccess',
  function prepare(response) {
    return {
      payload: response
    };
  }
);

const fetchAPRData = createAction('calculator/fetchAPR', function prepare() {
  return {
    payload: {
      endPoint: `/ref/content/productinfo/personal_loans?filter=A`,
      method: 'get',
      isPaasApi: true,
      addHeader: true,
      success: onFetchAPRSuccess,
      failure: onFetchAPRFailure,
      version: '1.0.0',
      useAuth: false
    }
  };
});

const setSelectedLoanInfo = createAction(
  'calculator/setSelectedLoanInfo',
  function prepare(payload) {
    return {
      payload
    };
  }
);

const fetchIllustrationSuccessResponse = createAction(
  'calculator/fetchIllustrationSuccess',
  function prepare(response, param) {
    const { term, apr, loanAmount, repExampleAmount } = param;
    return {
      payload: { response, term, apr, loanAmount, repExampleAmount }
    };
  }
);

const onFetchIllustrationSuccess = (response, param) => (dispatch) => {
  dispatch(fetchIllustrationSuccessResponse(response, param));
};

const onFetchIllustrationFailure = (response) => (dispatch) => {
  dispatch(responseFailed(response));
};

const fetchIllustrationData = createAction(
  'calculator/fetchIllustration',
  function prepare(
    loanAmount,
    apr,
    startDate,
    termInMonths,
    term,
    repExampleAmount = false //amount should not be update when it calls from informed choice
  ) {
    return {
      payload: {
        endPoint: '/banks/CB/loan/illustration/calculate/personal',
        method: 'post',
        body: JSON.stringify({
          loan: {
            amount: loanAmount,
            apr,
            repayment_start_date: startDate,
            term: termInMonths
          }
        }),
        isPaasApi: true,
        addHeader: true,
        success: onFetchIllustrationSuccess,
        successParam: {
          term,
          apr,
          loanAmount,
          repExampleAmount
        },
        failure: onFetchIllustrationFailure,
        version: '1.2.0',
        useAuth: false
      }
    };
  }
);

const resetIllustrationData = createAction('calculator/resetIllustrationData', function prepare() {
  return {
    payload: []
  };
});

const saveOldIllustrationDataForDIP = createAction(
  'calculator/saveOldIllustrationDataForDIP',
  function prepare(data) {
    return {
      payload: data
    };
  }
);

export {
  fetchAPRData,
  fetchAPRSuccessResponse,
  fetchIllustrationData,
  fetchIllustrationSuccessResponse,
  resetIllustrationData,
  setSelectedLoanInfo,
  saveOldIllustrationDataForDIP
};
